module.exports = __webpack_public_path__ + "static/media/pets-feeding.3f4b0431.png";